import React from 'react'
import { Sidenav } from '../SideNav/Sidenav'
import './CreateAccount.css';
import { CustomNavbar } from '../CustomNavbar/customnabar';
import { useLocation, useNavigate} from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { conn } from '../../Utilt/conn';
import Loader from '../Loader/Loader';
import { Modal, Box } from '@mui/material';
import { Modalstyle } from '../Modals/UploadImage/UploadImageModalStyle';
import done from '../../Assets/ICONS/done.png';
import copy from '../../Assets/ICONS/copy.png';
import Layout from '../../ReuseComponent/Layout/Layout';




function CreateAccount() {

  const location = useLocation();

  const navigate = useNavigate();

  const token = window.localStorage.getItem("token")

  const refreshtoken = window.localStorage.getItem("refreshtoken")


  const config = {
    headers: {
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin': '*',
      'token': token,
      'refreshtoken': refreshtoken
    }
  };
  

  useEffect(()=>{
     (location.state == null) && navigate("/");
  })
  
  const user_id = (location.state !== null )?location.state.id:"";

  const [signingUp, setSigningUp] = useState(false);

  //Modal
  const [signOpen, setSignOpen] = useState(false);
  const opensign = () => setSignOpen(true)
  const closesign = () => {setSignOpen(false);  navigate("/welcome")}
  //Modal


  const [accNumber, setAccNumber] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [accName, setAccName] = useState("");

  const formik = useFormik({

    initialValues: {
      account_name: "",
      zikora_user_id: user_id,
      nok_name: "",
      nok_phone: "",
      id_num: "",
    },

    validationSchema: Yup.object(
      {
        account_name: Yup.string().min(2, "Invalid Account Name").required("required"),
        nok_name: Yup.string().min(2, "Invalid Name Field").required("required"),
        nok_phone: Yup.string().required("required").max(11, "Invalid Phone Number"),
        id_num: Yup.string().min(6, "Must be 6 characters long").required("required")
      }
    ),

    onSubmit: async(values)=>{
      console.log(values)

      setSigningUp(true);

      await axios.put(conn+"/user/createBankAccount", JSON.stringify(values), config)
      .then((value)=>{
        setSigningUp(false);
        console.log(value.data);
        setAccNumber(value.data.account_number)
        setCustomerId(value.data.customer_id)
        setAccName(value.data.account_name)
        opensign()
      }).catch((error)=>{
        setSigningUp(false);
        console.log(error);
        if (error.response.status === 401) navigate('/login')
      })

    }

  })

  return (
    <div>

      <Layout label={'create-account'}>
          <section className='content'>

  <p>Kindly fill out the details to create new bank account</p>

  <section className='details'>

    <p>Details</p>


    <div className='grid'>

      <form onSubmit={formik.handleSubmit}>

        <div className='form-input'>
          <label>Account Name</label>
          <input type="text" name="account_name" value={formik.values.account_name} onChange={formik.handleChange} placeholder='Enter Preferred Account Name' />
          <p>{formik.errors.account_name && formik.errors.account_name}</p>
        </div>

        <div className='form-input'>
          <label>Next of Kin</label>
          <input type="text" name="nok_name" value={formik.values.nok_name} onChange={formik.handleChange} placeholder="What's Your Next-Of-Kin's Name?" />
          <p>{formik.errors.nok_name && formik.errors.nok_name}</p>
        </div>

        <div className='form-input'>
          <label>Next Of Kin Phone Number</label>
          <input type="text" name="nok_phone" value={formik.values.nok_phone} onChange={formik.handleChange} placeholder="What's your Next-Of-Kin's Phone number?" />
          <p>{formik.errors.nok_phone && formik.errors.nok_phone}</p>
        </div>

        <div className='form-input'>
          <label>ID Number</label>
          <input type="text" name="id_num" value={formik.values.id_num} onChange={formik.handleChange} placeholder="Enter your ID Number (Passport, Driver's License.. etc)" />
          <p>{formik.errors.id_num && formik.errors.id_num}</p>
        </div>

      

          <div></div>

          <div style={{ display: "inline-flex", justifyContent: "flex-end", margin: "40px 70px 0px 0px" }}>
            <button type="button" onClick={()=>{
              formik.handleSubmit()
              }} className='sub-btn'>Submit</button>
          </div>
          
          <div></div>

          <div>{signingUp && <Loader />}</div>

      </form>

    </div>


  </section>

          </section>
      </Layout>
      <Modal
        open={signOpen}
        onClose={closesign}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={Modalstyle}>

        <center style={{height:"80vh", display:"inline-flex", width:"100%", flexDirection:"column", alignItems:"center"}}>
          <img src={done} /> 
          <p style={{margin:"2vh 0"}} className='head'>Success</p>
          <p style={{margin:"1vh 0"}} className='head2'>Account has been created</p>

          <div className='detail-row'>
            <label>Account Name</label>
            <div class="one-row">Hyefur Jonathan</div>
          </div>

          <div className='detail-row'>
            <label>Account Number</label>
            <div class="two-row">
              <img src={copy} width="15px" height="15px" />
              <span>{accNumber}</span>
            </div>
          </div>


          <div className='detail-row'>
            <label>Customer ID</label>
            <div class="two-row">
              <img src={copy} width="15px" height="15px" />
              <span>{customerId}</span>
            </div>
          </div>


          <div className='btn-container'>
              <button className="btn" onClick={closesign} style={{width:"100%"}}>Done</button>
          </div>


        </center>
        
        </Box>
      </Modal>
    </div>

   

  )
}

export default CreateAccount